module.exports = __webpack_public_path__ + "img/aliens-body.aeee06ca.png";